import { render, staticRenderFns } from "./MapPOIs.vue?vue&type=template&id=1867ceda"
import script from "./MapPOIs.vue?vue&type=script&lang=js"
export * from "./MapPOIs.vue?vue&type=script&lang=js"
import style0 from "./MapPOIs.vue?vue&type=style&index=0&id=1867ceda&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports